// Mint-OpsCost (1536) · Chi phí dùng chung theo mảng — mảng Trucking. Dữ liệu mẫu + logic thuần, chép từ script board (số liệu nghìn ₫, tên đã che).
// Mã phí 3 ký tự chỉ dùng mã thật trong sysServiceCode; bản chất · người trả · chứng từ theo COST-LOGIC. TIỀN → màn gói sau quyền `money`.

export type Nature = 'OBH' | 'BIL' | 'ABS' | 'EXC';
export type Payer = 'BNK' | 'EMP';
export type DocKind = 'INV' | 'PND' | 'RCP' | 'NDC';
export type TripStatus = 'pnd' | 'apv' | 'ok' | 'set';
export type CatKey = 'drv' | 'lift' | 'toll' | 'fuel' | 'wait' | 'sup' | 'oth';
export type ColKey = 'drv' | 'lift' | 'toll' | 'fuel' | 'other';
export type CargoKind = 'RF' | 'DC' | 'LCL';
export type OpsTab = 'row' | 'cat' | 'ppl';
export type Period = 'w' | 'm';
export type OpsChip = 'pnd' | 'apv' | 'over' | 'unset';

export const FEE_NAME: Readonly<Record<string, string>> = {
  TRF: 'Lương chặng tài xế', ONN: 'Phí cấp rỗng', OFF: 'Hạ bãi', LNF: 'Nâng hạ', XLH: 'Phí cầu đường · VETC', FUE: 'Xăng dầu', TRS: 'Lưu ca / lưu bãi', LCH: 'Bốc xếp / nhân công',
  LFE: 'Xe nâng', GFE: 'Vé cổng', CLE: 'Vệ sinh cont', DPF: 'In ấn chứng từ', TRA: 'Phụ thu ghép điểm',
};
export const STATUS_LABEL: Readonly<Record<TripStatus, string>> = { pnd: 'Chờ chứng từ', apv: 'Chờ duyệt', ok: 'Đã duyệt', set: 'Đã quyết toán' };
export const CARGO_LABEL: Readonly<Record<CargoKind, string>> = { RF: 'Hàng lạnh', DC: 'Hàng khô', LCL: 'Hàng lẻ' };
export const NATURE_LABEL: Readonly<Record<Nature, string>> = { OBH: 'Chi hộ', BIL: 'Giá vốn có bán lại', ABS: 'HANA chịu', EXC: 'Bất thường' };
export const PAYER_LABEL: Readonly<Record<Payer, string>> = { BNK: 'Công ty trả', EMP: 'Nhân viên trả' };

/** Tên hiển thị của người giữ tạm ứng (board `NM`). */
export const PERSON: Readonly<Record<string, string>> = { HAI: 'HẢI', TUNG: 'TÙNG', LOI: 'LỢI', PHUC: 'PHÚC', NAM: 'NAM', VINH: 'VINH' };
/** Có ảnh đại diện (board `SF`): 1 = có ảnh, 0 = chưa. */
export const HAS_PHOTO: Readonly<Record<string, boolean>> = { HAI: true, TUNG: false, LOI: true, PHUC: false, NAM: true, VINH: false };
/** Tạm ứng đang giữ + hạn quyết toán (ngày tháng 10) của tài xế (board `PPL`: [xe, tạm ứng, hạn]). */
export const HOLDERS: Readonly<Record<string, readonly [string, number, number]>> = {
  HAI: ['50E13970', 4000, 27], TUNG: ['51D21458', 2000, 24], LOI: ['50H07731', 5000, 23], PHUC: ['51C66902', 1000, 31], NAM: ['50E20419', 1500, 29], VINH: ['51D33087', 1000, 21],
};

/** Đơn giá theo bậc (nghìn ₫ / km); lương cơ bản chuyến 300, điểm chen 200. */
const TIER: Readonly<Record<string, number>> = { Tier1: 3.0, Tier2: 2.6, Tier3: 2.4, Tier4: 2.2 };

/** Nhóm loại phí của mảng Trucking (board `DOM.TRF.cats`). */
export const CATS: readonly { key: CatKey; name: string; codes: readonly string[] }[] = [
  { key: 'drv', name: 'Lương tài xế', codes: ['TRF'] },
  { key: 'lift', name: 'Nâng hạ', codes: ['LNF', 'ONN', 'OFF'] },
  { key: 'toll', name: 'VETC', codes: ['XLH'] },
  { key: 'fuel', name: 'Dầu', codes: ['FUE'] },
  { key: 'wait', name: 'Lưu ca / chờ', codes: ['TRS'] },
  { key: 'sup', name: 'Phí hỗ trợ dịch vụ vận tải', codes: ['LCH', 'LFE'] },
  { key: 'oth', name: 'Phí khác', codes: ['GFE', 'CLE', 'DPF'] },
];
/** 5 cột tiền của bảng theo chuyến → các nhóm loại phí cộng vào. */
export const COLS: readonly { key: ColKey; label: string; cats: readonly CatKey[] }[] = [
  { key: 'drv', label: 'Lương', cats: ['drv'] },
  { key: 'lift', label: 'Nâng hạ', cats: ['lift'] },
  { key: 'toll', label: 'VETC', cats: ['toll'] },
  { key: 'fuel', label: 'Dầu', cats: ['fuel'] },
  { key: 'other', label: 'Phí khác', cats: ['wait', 'sup', 'oth'] },
];

// [mã, diễn giải, số tiền, bản chất, người trả, chứng từ, định mức, số ảnh (null = không cần), tuỳ chọn]
type RawLine = readonly [string, string, number, Nature, Payer, DocKind, number, number | null, { rc?: 'ind' | 'biz'; own?: 'H'; nk?: string }?];
type RawStop = readonly [string, string, string];
type RawToll = readonly [string, string, number, 'ok' | 'month' | 'miss'];
type RawTrip = readonly [string, number, string, string, string, string, CargoKind, readonly RawStop[], number, string, number, TripStatus, readonly RawLine[], readonly RawToll[], number, readonly (readonly [string, string, string, number])[]];

const TRIPS: readonly RawTrip[] = [
  ['TRF2610078', 22, 'HAI', '50E13970', 'SE260637420', '1×40HC', 'DC', [['ICD Phước Long 3', 'Lấy rỗng', '05:58'], ['Kho SAVITA · Bình Dương', 'Đóng hàng', '08:12'], ['Cát Lái Giang Nam', 'Hạ hàng', '14:02']], 46, 'Tier1', 0, 'apv',
    [['ONN', 'Nâng rỗng – chuẩn · ICD Phước Long 3', 286, 'BIL', 'EMP', 'INV', 286, 1], ['FUE', 'Dầu DO · Petrolimex CH 47 · tạm ứng TU-2610-036', 1850, 'ABS', 'EMP', 'INV', 1800, 1], ['XLH', 'Cầu đường ngoài VETC · ảnh mờ, chụp lại', 35, 'ABS', 'EMP', 'RCP', 35, 0], ['TRS', 'Lưu ca · chờ kho 4h28′', 100, 'ABS', 'BNK', 'RCP', 100, null]],
    [['An Phú (CORR01)', '06:44', 52, 'ok'], ['An Phú (CORR01)', '13:18', 52, 'ok']], 104, [['TRS', 'Chờ kho quá giờ', '4h28′ · miễn 2h · 3h × 200.000', 600]]],
  ['TRF2610081', 21, 'TUNG', '51D21458', 'SE260619420', '1×40HC', 'DC', [['Cát Lái', 'Lấy rỗng', '05:40'], ['Kho Khải Doanh (vỏ sò)', 'Đóng hàng', '09:10'], ['COCOGROUP', 'Đóng hàng', '11:30'], ['Cát Lái', 'Hạ hàng', '16:20']], 194.2, 'Tier2', 1, 'pnd',
    [['ONN', 'Phí cấp rỗng · Cát Lái', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · Cát Lái · ngoài giờ', 680, 'BIL', 'EMP', 'PND', 520, 0], ['FUE', 'Xăng dầu · 60 L', 1191, 'BIL', 'EMP', 'RCP', 1151, 1], ['LCH', 'Bốc xếp tại kho · 2 người', 300, 'BIL', 'EMP', 'NDC', 240, 1, { rc: 'ind' }], ['GFE', 'Vé cổng · Cát Lái', 50, 'BIL', 'EMP', 'RCP', 50, 1]],
    [['Phú Mỹ', '06:20', 75, 'ok'], ['Cầu Rạch Miễu', '08:35', 0, 'month'], ['Cầu Rạch Miễu', '12:40', 0, 'month'], ['Phú Mỹ', '15:30', 75, 'ok']], 150, [['TRA', 'Kho thêm · COCOGROUP', 'Điểm chen 1 · theo biểu', 800]]],
  ['TRF2610083', 20, 'LOI', '50H07731', 'RE260670680', '1×40RH', 'RF', [['Cát Lái', 'Lấy hàng', '05:10'], ['Kho Ngọc Kim Loan', 'Rút hàng', '11:45'], ['Phú Hưng Depot', 'Hạ rỗng', '19:30']], 338.7, 'Tier4', 0, 'ok',
    [['LNF', 'Nâng hàng · Cát Lái', 520, 'BIL', 'EMP', 'INV', 520, 1], ['OFF', 'Hạ rỗng · Phú Hưng Depot', 480, 'OBH', 'EMP', 'INV', 480, 1, { own: 'H' }], ['FUE', 'Xăng dầu · 116 L', 2303, 'BIL', 'EMP', 'RCP', 2025, 1, { nk: '102 L' }], ['GFE', 'Vé cổng · Cát Lái', 50, 'BIL', 'EMP', 'RCP', 50, 1]],
    [['Phú Mỹ', '05:35', 75, 'ok'], ['Nguyen Van Linh Toll Plaza', '05:52', 0, 'month'], ['Km51 → Cai Lậy (CORR12)', '07:10', 180, 'ok'], ['Cai Lậy → Km51 (CORR12)', '15:55', 180, 'miss'], ['Phú Mỹ', '18:40', 75, 'ok']], 510, []],
  ['TRF2610085', 19, 'PHUC', '51C66902', 'SE260618870', '1×20DC', 'DC', [['Cát Lái', 'Lấy rỗng', '07:00'], ['Kho Hoàng Lai (Sài Gòn)', 'Đóng hàng', '08:15'], ['Cát Lái', 'Hạ hàng', '11:40']], 18.6, 'Tier1', 0, 'set',
    [['LNF', 'Nâng hạ · Cát Lái', 350, 'BIL', 'EMP', 'INV', 350, 2], ['FUE', 'Xăng dầu · 6 L', 119, 'BIL', 'EMP', 'RCP', 119, 1], ['GFE', 'Vé cổng · Cát Lái', 50, 'BIL', 'EMP', 'RCP', 50, 1]],
    [['An Phú (CORR01)', '07:22', 52, 'ok']], 52, []],
  ['TRF2610086', 22, 'NAM', '50E20419', 'SE260619510', '1×40RH', 'RF', [['Tân Cảng Mỹ Thủy 1', 'Lấy rỗng', '06:30'], ['Kho lạnh Hoàn Vũ', 'Đóng hàng', '07:40'], ['Cát Lái', 'Hạ hàng', '13:20']], 21.4, 'Tier1', 0, 'apv',
    [['ONN', 'Phí cấp rỗng · Mỹ Thủy', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · Cát Lái', 520, 'BIL', 'EMP', 'INV', 520, 1], ['FUE', 'Xăng dầu · 7 L', 139, 'BIL', 'EMP', 'RCP', 139, 1], ['TRS', 'Lưu ca · chờ cắm điện', 200, 'ABS', 'BNK', 'RCP', 100, null]],
    [['An Phú (CORR01)', '06:55', 52, 'ok']], 52, [['TRS', 'Lưu mooc', 'Mooc lưu 30h · 1 ngày × 500.000', 500]]],
  ['TRF2610088', 21, 'VINH', '51D33087', 'SE260619388', '1×40HC', 'DC', [['ICD Phước Long 3', 'Lấy rỗng', '06:00'], ['CTY NIPPON RIKA', 'Đóng hàng', '07:30'], ['Cát Lái', 'Hạ hàng', '12:10']], 42.3, 'Tier1', 0, 'pnd',
    [['ONN', 'Phí cấp rỗng · ICD Phước Long 3', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · Cát Lái', 520, 'BIL', 'EMP', 'INV', 520, 1], ['FUE', 'Xăng dầu · 14 L', 278, 'BIL', 'EMP', 'RCP', 258, 1], ['LFE', 'Xe nâng tại kho · NIPPON RIKA', 250, 'BIL', 'EMP', 'NDC', 250, 0, { rc: 'biz' }]],
    [['BOT An Sương–An Lạc', '06:40', 50, 'ok'], ['BOT An Sương–An Lạc', '11:20', 50, 'miss']], 100, []],
  ['TRF2610090', 16, 'HAI', '50E13970', 'SE260618990', '1×40RH', 'RF', [['Cát Lái', 'Lấy rỗng', '04:50'], ['Kho Tam Ngọc Cờ Đỏ', 'Đóng hàng', '09:30'], ['Cát Lái', 'Hạ hàng', '16:05']], 186.2, 'Tier3', 0, 'apv',
    [['ONN', 'Phí cấp rỗng · Cát Lái', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · Cát Lái', 520, 'BIL', 'EMP', 'INV', 520, 1], ['FUE', 'Xăng dầu · 57 L', 1131, 'BIL', 'EMP', 'RCP', 1112, 1], ['LCH', 'Bốc xếp tại kho Cờ Đỏ', 200, 'ABS', 'EMP', 'RCP', 240, 1, { rc: 'ind' }], ['GFE', 'Vé cổng · Cát Lái', 50, 'BIL', 'EMP', 'RCP', 50, 1]],
    [['Long Phước', '05:20', 150, 'ok'], ['Trung Lương', '06:10', 180, 'ok'], ['Mỹ Thuận 2', '07:40', 105, 'ok'], ['Mỹ Thuận 2', '12:50', 105, 'ok'], ['Trung Lương', '14:20', 180, 'ok'], ['Long Phước', '15:30', 150, 'ok']], 870, []],
  ['TRF2610092', 14, 'TUNG', '51D21458', 'SE260618720', '1×40HC', 'DC', [['TCIT Cái Mép', 'Lấy rỗng', '06:10'], ['TRUNGPHAT', 'Đóng hàng', '08:20'], ['TCIT Cái Mép', 'Hạ hàng', '12:40']], 88.4, 'Tier2', 0, 'ok',
    [['ONN', 'Phí cấp rỗng · TCIT', 500, 'BIL', 'EMP', 'INV', 500, 1], ['OFF', 'Hạ hàng · TCIT', 560, 'BIL', 'EMP', 'INV', 560, 1], ['FUE', 'Xăng dầu · 27 L', 536, 'BIL', 'EMP', 'RCP', 536, 1], ['GFE', 'Vé cổng · Cái Mép', 60, 'BIL', 'EMP', 'RCP', 60, 1], ['CLE', 'Vệ sinh cont', 100, 'BIL', 'EMP', 'INV', 100, 1], ['DPF', 'In phiếu EIR', 10, 'BIL', 'EMP', 'RCP', 10, 1]],
    [['Phú Mỹ', '07:05', 75, 'ok'], ['Phú Mỹ', '11:50', 75, 'ok']], 150, []],
  ['TRF2610070', 9, 'LOI', '50H07731', 'SE260617950', '1×40HC', 'DC', [['ICD Tanamexco', 'Lấy rỗng', '06:00'], ['Ba Sương - Đồng Nai', 'Đóng hàng', '08:10'], ['ICD Tanamexco', 'Hạ hàng', '12:30']], 61.8, 'Tier2', 0, 'ok',
    [['ONN', 'Phí cấp rỗng · ICD Tanamexco', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · ICD Tanamexco', 450, 'BIL', 'EMP', 'INV', 450, 1], ['FUE', 'Xăng dầu · 19 L', 377, 'BIL', 'EMP', 'RCP', 377, 1], ['GFE', 'Vé cổng · ICD', 50, 'BIL', 'EMP', 'RCP', 50, 1]],
    [['BOT Tân Phú', '06:50', 70, 'ok'], ['BOT Tân Phú', '11:40', 70, 'ok']], 140, []],
  ['TRF2610066', 7, 'PHUC', '51C66902', 'SE260617730', '1×40HC', 'DC', [['ICD Phước Long 3', 'Lấy rỗng', '07:00'], ['CTY NIPPON RIKA', 'Đóng hàng', '08:30'], ['ICD Phước Long 3', 'Hạ hàng', '12:00']], 42.3, 'Tier1', 0, 'set',
    [['ONN', 'Phí cấp rỗng · ICD Phước Long 3', 450, 'BIL', 'EMP', 'INV', 450, 1], ['OFF', 'Hạ hàng · ICD Phước Long 3', 450, 'BIL', 'EMP', 'INV', 450, 1], ['FUE', 'Xăng dầu · 13 L', 258, 'BIL', 'EMP', 'RCP', 258, 1]],
    [['BOT An Sương–An Lạc', '07:30', 50, 'ok'], ['BOT An Sương–An Lạc', '11:30', 50, 'ok']], 100, []],
];

export interface OpsLine {
  key: string;
  code: string;
  name: string;
  amt: number;
  nat: Nature;
  pay: Payer;
  doc: DocKind;
  norm: number | null;
  cat: CatKey;
  /** Số ảnh chứng từ; null = dòng tự tính (lương chặng, VETC) không cần ảnh. */
  ph: number | null;
  rc?: 'ind' | 'biz';
  own?: 'H';
  nk?: string;
  /** Lương chặng theo bậc km (chỉ dòng TRF): [nhãn, ghi chú, số tiền]. */
  wage?: readonly (readonly [string, string, number])[];
}
export interface OpsStop { name: string; role: string; at: string }
export interface OpsToll { name: string; at: string; amt: number; match: 'ok' | 'month' | 'miss' }
export interface OpsSell { code: string; name: string; formula: string; amt: number }
export interface OpsTrip {
  id: string;
  job: string;
  day: number;
  ppl: string;
  name: string;
  veh: string;
  cont: string;
  cg: CargoKind;
  from: string;
  to: string;
  stops: string[];
  extra: number;
  status: TripStatus;
  vMonth: number;
  vMiss: number;
  lines: OpsLine[];
  tot: number;
  emp: number;
  overs: OpsLine[];
  hay: string;
  km: number;
  tier: string;
  stopList: OpsStop[];
  vetc: OpsToll[];
  sell: OpsSell[];
}

/** Số theo board: nghìn ₫, dấu chấm hàng nghìn, âm dùng dấu −. */
export const th = (n: number): string => (n < 0 ? '−' : '') + String(Math.round(Math.abs(n))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
/** Số đầy đủ đơn vị ₫ (tooltip). */
export const fullVnd = (kn: number): string => th(kn * 1000) + ' ₫';
export const pct = (p: number): string => (p > 0 ? '+' : '') + Math.round(p * 100) + '%';
export const MASK = '••••';

/** Dòng vượt định mức khi thực tế > định mức × 1,05 + 0,5 (board `overOf`). */
export const isOver = (x: OpsLine): boolean => x.norm != null && x.norm > 0 && x.amt > x.norm * 1.05 + 0.5;

const catOf = (code: string): CatKey => CATS.find((c) => c.codes.includes(code))?.key ?? 'oth';

function build(a: RawTrip): OpsTrip {
  const [id, day, ppl, veh, job, cont, cg, stops, km, tier, extra, status, ls, vetc, vstd] = a;
  const rawW = 300 + TIER[tier]! * km;
  const salR = Math.round(rawW / 100) * 100;
  const sal = salR + 200 * extra;
  const kmS = String(km).replace('.', ',');
  const wageRows: [string, string, number][] = [['Cơ bản chuyến', '', 300], [`${tier} · ${th(TIER[tier]! * 1000)} ₫/km`, `${kmS} km`, TIER[tier]! * km], ['Làm tròn 100.000', '', salR - rawW]];
  if (extra) wageRows.push(['Điểm chen', `${extra} × 200.000`, 200 * extra]);
  const wage: OpsLine = { key: `${id}:w`, code: 'TRF', name: `Lương chặng · ${tier} · ${kmS} km`, amt: sal, nat: 'BIL', pay: 'BNK', doc: 'RCP', norm: sal, cat: 'drv', ph: null, wage: wageRows };
  const vl: OpsLine = { key: `${id}:v`, code: 'XLH', name: `VETC · ${vetc.filter((v) => v[3] !== 'month').length} lượt`, amt: vetc.reduce((s, v) => s + v[2], 0), nat: 'BIL', pay: 'BNK', doc: 'INV', norm: vstd, cat: 'toll', ph: null };
  const rest: OpsLine[] = ls.map((x, i) => ({ key: `${id}:${i}`, code: x[0], name: x[1], amt: x[2], nat: x[3], pay: x[4], doc: x[5], norm: x[6], cat: catOf(x[0]), ph: x[7], ...x[8] }));
  const lines = [wage, ...rest, vl];
  const middle = stops.slice(1, -1).map((s) => s[0])[0];
  const to = middle ?? stops[stops.length - 1]![0];
  const name = PERSON[ppl] ?? ppl;
  const from = stops[0]![0];
  return {
    id, job, day, ppl, name, veh, cont, cg, from, to, stops: stops.map((s) => s[0]), extra, status,
    vMonth: vetc.filter((v) => v[3] === 'month').length, vMiss: vetc.filter((v) => v[3] === 'miss').length,
    lines, tot: lines.reduce((s, x) => s + x.amt, 0), emp: lines.filter((x) => x.pay === 'EMP').reduce((s, x) => s + x.amt, 0), overs: lines.filter(isOver),
    km, tier, stopList: stops.map((q) => ({ name: q[0], role: q[1], at: q[2] })), vetc: vetc.map((v) => ({ name: v[0], at: v[1], amt: v[2], match: v[3] })),
    sell: (a[15] ?? []).map((v) => ({ code: v[0], name: v[1], formula: v[2], amt: v[3] })),
    hay: [id, job, name, ppl, veh, from, to, cont].join(' ').toLowerCase(),
  };
}
export const ALL_TRIPS: readonly OpsTrip[] = TRIPS.map(build);

/** Tuần hiện tại 19–25/Oct; `off` ≤ 0 là số kỳ lùi lại. Tháng: chỉ kỳ hiện tại có dữ liệu mẫu. */
export function inPeriod(day: number, per: Period, off: number): boolean {
  const w0 = 19 + off * 7;
  return per === 'w' ? day >= w0 && day <= w0 + 6 : off === 0;
}
export const dayLabel = (d: number): string => (d < 1 ? String(d + 30).padStart(2, '0') + '/Sep' : String(d).padStart(2, '0') + '/Oct');
export function periodLabel(per: Period, off: number): { k: string; tip: string } {
  const w0 = 19 + off * 7;
  return per === 'w'
    ? { k: `T${43 + off} · ${dayLabel(w0).slice(0, 2)}–${dayLabel(w0 + 6)}`, tip: `Tuần ${43 + off} · ${dayLabel(w0)} – ${dayLabel(w0 + 6)}/2026` }
    : { k: `T${10 + off}/2026`, tip: `Tháng ${10 + off}/2026` };
}

export const sumCats = (t: OpsTrip, keys: readonly CatKey[]): number => t.lines.filter((x) => keys.includes(x.cat)).reduce((s, x) => s + x.amt, 0);
/** Các dòng vượt định mức trong một cột tiền (để hiện cờ cạnh số). */
export const overInCols = (t: OpsTrip, keys: readonly CatKey[]): OpsLine[] => t.lines.filter((x) => keys.includes(x.cat) && isOver(x));
export const overTip = (ov: readonly OpsLine[]): string =>
  `Vượt định mức · ${ov.map((x) => `${x.code} ${pct((x.amt - (x.norm ?? 0)) / (x.norm ?? 1))}`).join(' · ')} · mở định mức`;

export interface OpsFilter {
  ppl: readonly string[];
  veh: readonly string[];
  status: readonly TripStatus[];
  chip: OpsChip | '';
  q: string;
}
export const NO_FILTER: OpsFilter = { ppl: [], veh: [], status: [], chip: '', q: '' };

export function chipPass(t: OpsTrip, k: OpsChip): boolean {
  if (k === 'pnd') return t.status === 'pnd';
  if (k === 'apv') return t.status === 'apv';
  if (k === 'over') return t.overs.length > 0;
  return t.status !== 'set' && t.emp > 0;
}
export function passFilter(t: OpsTrip, f: OpsFilter): boolean {
  const ql = f.q.trim().toLowerCase();
  return (!f.ppl.length || f.ppl.includes(t.ppl)) && (!f.veh.length || f.veh.includes(t.veh)) && (!f.status.length || f.status.includes(t.status)) && (!f.chip || chipPass(t, f.chip)) && (!ql || t.hay.includes(ql));
}
export const tripsInPeriod = (per: Period, off: number): OpsTrip[] => ALL_TRIPS.filter((t) => inPeriod(t.day, per, off));

/** Tổng theo loại phí (tab "Theo loại phí"): số dòng · định mức · thực tế · số dòng vượt. */
export function catTotals(trips: readonly OpsTrip[]) {
  const lines = trips.flatMap((t) => t.lines);
  return CATS.map((c) => {
    const ls = lines.filter((x) => x.cat === c.key);
    const act = ls.reduce((s, x) => s + x.amt, 0);
    const nm = ls.reduce((s, x) => s + (x.norm == null ? x.amt : x.norm), 0);
    return { ...c, n: ls.length, act, norm: nm, over: ls.filter(isOver).length };
  });
}

/** Tổng theo tài xế (tab "Theo tài xế"): tạm ứng giữ · đã chi · chờ duyệt · cần quyết toán · số dư · hạn. */
export function driverTotals(trips: readonly OpsTrip[]) {
  const people = trips.map((t) => t.ppl).filter((p, i, a) => a.indexOf(p) === i);
  return people.map((p) => {
    const [veh, adv, due] = HOLDERS[p] ?? ['', 0, 31];
    const mine = trips.filter((t) => t.ppl === p);
    const spent = mine.filter((t) => t.status !== 'set').reduce((s, t) => s + t.emp, 0);
    const pend = mine.filter((t) => t.status === 'apv' || t.status === 'pnd').reduce((s, t) => s + t.emp, 0);
    const need = mine.filter((t) => t.status === 'ok').reduce((s, t) => s + t.emp, 0);
    const bal = adv - spent;
    const dl = due - 22;
    return { ppl: p, name: PERSON[p] ?? p, veh, n: mine.length, adv, spent, pend, need, bal, due, late: due < 22, dueSoon: dl >= 0 && dl <= 2, dueLabel: due < 22 ? `−${22 - due} ngày` : `${String(due).padStart(2, '0')}/Oct` };
  });
}
